<template>
  <div>
    <!--<a id="show-sidebar" class="btn btn-sm btn-dark" href="javascript:void(0)" onclick="showSidebar();">-->
    <a id="show-sidebar" class="btn btn-sm btn-dark" href="javascript:void(0)">
      <i class="fas fa-bars"></i>
    </a>
    <nav id="sidebar" class="sidebar-wrapper">
      <div class="sidebar-content">
        <div class="sidebar-brand">
          <a href="javascript:void(0)" @click="gohome()"><img src="static/images/logo_white.png" alt=""></a>
          <!--<div id="close-sidebar" onclick="closeSidebar();">-->
          <div id="close-sidebar">
            <i class="fas fa-times"></i>
          </div>
        </div>
        <div class="sidebar-menu">
          <ul>
            <!--<li class="sidebar-dropdown active" id="ck-test-menu" onclick="sidebarDropdown(this);">-->
            <li class="sidebar-dropdown active" id="ck-orderplanning-menu">
              <a href="javascript:void(0)">
                <i class="fa fa-cube"></i>
                <span>User Management</span>
              </a>
              <div class="sidebar-submenu" style="display: block;">
                <ul>
                  <li v-if="hasPermission('View Users')" class="select-image" v-bind:class="{ active: $store.getters.selectedTab=='users' }" @click="goUsers()">
                    <a href="javascript:void(0)">Users</a>
                  </li>
                  <li v-if="hasPermission('View Roles')" class="select-image" v-bind:class="{ active: $store.getters.selectedTab=='roles' }" @click="goRoles()">
                    <a href="javascript:void(0)">Roles</a>
                  </li>
                  <li v-if="hasPermission('View Logs')"
                      class="select-image"
                      v-bind:class="{ active: $store.getters.selectedTab=='logs' }"
                      @click="goLogs()">
                    <a href="javascript:void(0)">Logs</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <!-- sidebar-menu  -->
      </div>
      <!-- sidebar-content  -->
      <div class="sidebar-footer">
        <a href="javascript:void(0)">
          {{userName}}
          <!--<span><?=$_SESSION['authuser']?></span>-->
        </a>
        <!--<a href="javascript:void(0)">
            <i class="fa fa-cog"></i>
        </a>-->
        <a href="javascript:void(0)" @click="confirmLogout()" data-toggle="tooltip" data-placement="top" title="Logout">
          <i class="fa fa-power-off"></i>
        </a>
      </div>
    </nav>
    <!-- sidebar-wrapper  -->
  </div>
</template>

<script>
  import { bus } from './../../../main.js'

  export default {
    name: 'MainSidebar',
    props: {
      hasPermission: {
        type: Function,
        required: true
      }
    },
    data() {
      return {
        userName: localStorage.getItem('username')
      }
    },
    methods: {
      goUsers() {
        // 1) Keep the store state consistent (selectedTab = 'users')
        this.$store.commit('selectedTab', 'users');

        // 2) Tell any listeners to reset Users page to root view
        bus.$emit('nav:users-root');
      },
      goRoles() {
        // 1) Keep the store state consistent (selectedTab = 'users')
        this.$store.commit('selectedTab', 'roles');

        // 2) Tell any listeners to reset Users page to root view
        bus.$emit('nav:roles-root');
      },
      goLogs() {
        this.$store.commit('selectedTab', 'logs');
      },
      confirmLogout(){
        let vm = this;
        Swal.fire({
          title: 'Are you sure you want to logout?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then( function(result){
          if (result.value) {
            vm.$auth.destroyToken();
            // vm.$router.push('/');
            location.reload();
          }
        });
      },
      gohome(){
        this.$router.push('/');
        location.reload();
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/layout/MainSidebar.vue